export default __webpack_public_path__ + "static/media/7minfitness@3x.8b1285a6.jpg";